import { useState } from 'react'
import { objectToQueryString } from '../utils/utils'
import useFetch from '../hooks/useFetch'
import useSnackbar from '../hooks/useSnackbar'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()
  const { newMessage } = useSnackbar()

  const [isLoading, setIsLoading] = useState(false)
  const [testTask, setTestTask] = useState({})
  const [testTaskPost, setTestTaskPost] = useState({})
  const [jobs, setJobs] = useState([])
  const [jobHistory, setJobHistory] = useState([])

  const getOptions = { method: 'GET' }
  const postHeaders = { "Content-Type": "application/json" }

  const postOptions = (data) => ({
    method: 'POST',
    headers: postHeaders,
    body: JSON.stringify(data)
  })

  const fetchTestTask = async (options) => {
    try {
      setIsLoading(true)
      const data = await apiWrapper({
        fetch,
        url: `jobs/test?${objectToQueryString(options || {})}`
      });
      setTestTask(data)
      return data
    } catch (e) {
      newMessage({ message: e?.message || 'Error running test task post', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchTestTaskPost = async (options) => {
    try {
      setIsLoading(true)
      const data = await apiWrapper({
        fetch,
        url: `jobs/test`,
        options: postOptions(options || {})
      });
      setTestTaskPost(data)
      return data
    } catch (e) {
      newMessage({ message: e?.message || 'Error running test task', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchJobs = async () => {
    try {
      setIsLoading(true)
      const data = await apiWrapper({
        fetch,
        url: `jobs`,
        options: getOptions
      });
      setJobs(data)
      return data
    } catch (e) {
      newMessage({ message: e?.message || 'Error getting jobs', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchCreateJob = async (job) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `jobs/create`,
        options: postOptions(job)
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error creating job', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchUpdateJob = async (id, job) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `jobs/${id}/update`,
        options: postOptions(job)
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error updating job', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchToggleJob = async (id, enabled) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `jobs/${id}/toggle`,
        options: postOptions({ enabled })
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error updating job status', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchDeleteJob = async (id) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `jobs/${id}/delete`,
        options: postOptions({})
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error deleting job', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchRunJob = async (id) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `jobs/${id}/run`,
        options: postOptions({})
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error running job', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchJobHistory = async (id) => {
    try {
      setIsLoading(true)
      const data = await apiWrapper({
        fetch,
        url: `jobs/${id}/history`,
        options: getOptions
      });
      setJobHistory(data)
      return data
    } catch (e) {
      newMessage({ message: e?.message || 'Error getting job history', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    testTask,
    testTaskPost,
    jobs,
    jobHistory,
    fetchTestTask,
    fetchTestTaskPost,
    fetchJobs,
    fetchCreateJob,
    fetchUpdateJob,
    fetchToggleJob,
    fetchDeleteJob,
    fetchRunJob,
    fetchJobHistory,
  }
}
